// NATIVE 
import React from 'react';

// INSTALLED 
import { at } from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useField, useFormikContext } from 'formik';
import {
    Autocomplete,
    TextField
  } from '@mui/material';
  

// CUSTOM 
import { setDepartamentByCountryId } from '../../store/departament';

function AutocompleteFieldCountry(props:any) {

  const dispatch = useDispatch();

  const { label, options, onChange, element,  ...rest } = props;
  const formikProps = useFormikContext()
 
  const [field, meta, helper] = useField(props);

  const { value: selectedValue } = field;

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    
    if (touched && error) {
        return error;
    }
  }
 
    async function setDepartament (props:any) {
        formikProps.setFieldValue(field.name, props);
        await dispatch( setDepartamentByCountryId( props.value ) );
    }

  return (
        <Autocomplete
            onBlur={() => formikProps.setFieldTouched(field.name) }
            loading={true}
            disableClearable={true}
            loadingText={'Cargando...'}
            onChange={ (e,v) => setDepartament(v)  } 
            value={selectedValue ? selectedValue : ''}
            renderOption={(props, option:any) => {
              return (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              );
            }}
            options={options}
            renderInput={(params:any) => <TextField 
                                         
                                         helperText={_renderHelperText()} 
                                         {...params} 
                                         label={label} 
                                         error={meta.touched && meta.error && true}
                                      />}
        />
            
  );
}


AutocompleteFieldCountry.defaultProps = {
    options: [],
    name: '',
    label: '',
    setValue: '',
    element: '',
    onChange: () => {},
  };
  
  AutocompleteFieldCountry.propTypes = {
    options: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    element: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    setValue: PropTypes.string.isRequired
  };
  
  export default AutocompleteFieldCountry;